export default __webpack_public_path__ + "static/media/test-tube.a7c87d2f.png";